var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyMalaysia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_21408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9531 3.74072H0.046875V7.34072H59.9531V3.74072ZM59.9531 11.1188H0.046875V14.7188H59.9531V11.1188ZM59.9531 18.5063H0.046875V22.1063H59.9531V18.5063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0.046875H30V26.2969H60V0.046875Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5469 6.91875L39.9844 10.7344L37.8282 7.54688L38.9907 11.2219L35.6626 9.27188L38.2969 12.0844L34.4532 11.7844L38.0438 13.1719L34.4532 14.5594L38.2969 14.2594L35.6626 17.0719L38.9907 15.1219L37.8376 18.8063L39.9938 15.6094L40.5563 19.425L41.1094 15.6094L43.2657 18.7969L42.1032 15.1219L45.4313 17.0719L42.8063 14.2594L46.6501 14.5594L43.0501 13.1719L46.6407 11.7844L42.7969 12.0844L45.4313 9.27188L42.1032 11.2219L43.2657 7.5375L41.1094 10.7344L40.5469 6.91875ZM43.6688 7.07813C44.6836 6.62829 45.7947 6.439 46.9011 6.52744C48.0076 6.61588 49.0745 6.97925 50.005 7.58457C50.9354 8.18988 51.7 9.01798 52.2292 9.9937C52.7585 10.9694 53.0357 12.0619 53.0357 13.1719C53.0357 14.2819 52.7585 15.3743 52.2292 16.3501C51.7 17.3258 50.9354 18.1539 50.005 18.7592C49.0745 19.3645 48.0076 19.7279 46.9011 19.8163C45.7947 19.9048 44.6836 19.7155 43.6688 19.2656C44.7896 20.0698 46.1103 20.5492 47.4859 20.6513C48.8615 20.7534 50.2386 20.4741 51.4658 19.8443C52.693 19.2144 53.7227 18.2583 54.4416 17.0811C55.1606 15.9039 55.541 14.5513 55.541 13.1719C55.541 11.7925 55.1606 10.4398 54.4416 9.26266C53.7227 8.08547 52.693 7.12937 51.4658 6.49949C50.2386 5.86961 48.8615 5.59036 47.4859 5.69245C46.1103 5.79453 44.7896 6.274 43.6688 7.07813Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9531 25.8936H0.046875V29.4936H59.9531V25.8936ZM59.9531 33.2248H0.046875V36.8248H59.9531V33.2248ZM60 41.3998H0.09375V44.9998H60V41.3998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_21408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMalaysia);
export default __webpack_public_path__ + "static/media/my Malaysia.0fa3e269ce23c67b678ccb767dd9f681.svg";
export { ForwardRef as ReactComponent };